<template>
  <div class="Backorder__Container">
    <p :class="fontSize" data-color="night-sky-dark">
      {{ store?.$state?.terms?.backorder?.ships_by || 'Ships by ' }}
      {{ formattedDate }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useProductStore } from './Composables/Store';
const props = defineProps({
  date: String,
  fontSize: {
    type: String,
    required: false,
    default: 'd2',
  },
});
const store = useProductStore();
const formattedDate = computed(() => {
  return new Date(props.date).toLocaleDateString('en-us', {
    month: 'short',
    day: 'numeric',
  });
});
</script>
